// Bag-of-mots simple : chaque phrase devient un vecteur de longueur fixe
// (présence/absence de chaque mot du vocabulaire), construit une seule fois
// par entraînement à partir des phrases du dataset — jamais persisté, comme
// le modèle lui-même (Option B : tout est ré-entraîné dans le navigateur).
const WORD_PATTERN = /[a-zà-öø-ÿ']+/gi;
const MAX_VOCABULARY_SIZE = 200;

function tokenize(text: string): string[] {
  return (text.toLowerCase().match(WORD_PATTERN) || []).filter((word) => word.length > 1);
}

export function buildVocabulary(texts: string[], maxSize: number = MAX_VOCABULARY_SIZE): string[] {
  const counts = new Map<string, number>();
  texts.forEach((text) => {
    const seen = new Set(tokenize(text));
    seen.forEach((word) => counts.set(word, (counts.get(word) || 0) + 1));
  });
  return Array.from(counts.entries())
    .sort((a, b) => b[1] - a[1])
    .slice(0, maxSize)
    .map(([word]) => word)
    .sort();
}

export function vectorize(text: string, vocabulary: string[]): number[] {
  const present = new Set(tokenize(text));
  return vocabulary.map((word) => (present.has(word) ? 1 : 0));
}
